import React from "react"
import { graphql, Link } from "gatsby"

import Layout from '../components/layout'
// import Introduction from "../components/Service/Introduction"
import ServiceContent from "../components/Service/ServiceContent"
import ServicesList from "../components/Service/ServicesList"
import Breadcrumb from "../components/Global/Breadcrumb"
import Faqs from "../components/Global/Faqs"





function ServiceTemplate(props) {
    let data = props.data.wpgraphql;
    console.log(props)

    console.log(data)

    function getBreadcrumb() {
        let bCrumb = [];
        bCrumb.push({
            text: "Home",
            url: `${props.pageContext.language !== "EL" ? "/" + props.pageContext.language.toLowerCase() : "/"}`
        })
        bCrumb.push({
            text: data.service.serviceCategories.edges[0].node.breadcrumbServicesAcf.breadcrumbName,
            url: `${props.pageContext.language !== "EL" ? "/" + props.pageContext.language.toLowerCase() : ""}/${data.service.serviceCategories.edges[0].node.breadcrumbServicesAcf.breadcrumbSlug}/`
        })
        bCrumb.push({
            text: data.service.breadcrumbAcf.breadcrumbName,
        })
        return bCrumb;
    }

    function constructMetaData(page, currentPage, language) {
        let payload = {
            title: page.seo.title,
            description: page.seo.metaDesc,
            canonical: `https://plusmedical.gr${currentPage}`,
            fbTitle: page.seo.opengraphTitle ? page.seo.opengraphTitle : page.seo.title,
            fbDescription: page.seo.opengraphDescription ? page.seo.opengraphDescription : page.seo.metaDesc,
            fbUrl: `https://plusmedical.gr${currentPage}`,
            fbType: "website",
            locale: language.toLowerCase(),
            image: page.seo.opengraphImage ? page.seo.opengraphImage.sourceUrl : ""
        }
        return payload
    }

    return (
        <div>
            <Layout
                headerMenu={props.pageContext.headerMenu}
                footerMenu={props.pageContext.footerMenu}
                recentPosts={data.posts}
                currentPage={{ currentPage: props.pageContext.currentPage, language: props.pageContext.languageName }}
                availableVersions={props.pageContext.availablePages}
                metaData={constructMetaData(data.service, props.pageContext.currentPage, props.pageContext.language)}
                services={props.pageContext.servicesCategories}
                examinations={props.pageContext.examinationsCategories}
                preHeader={data.template.contactInformationTemplate}
            >
                <div>
                    {/* <section>
                        {data.service.servicesAcf.featuredImage && (
                            <Introduction backImg={data.service.servicesAcf.featuredImage} title={data.service.title} />
                        )}
                    </section> */}
                    {data.service.breadcrumbAcf.breadcrumbName && (
                        <section>
                            <Breadcrumb list={getBreadcrumb()} image={""} h1={data.service.breadcrumbAcf.breadcrumbName} />
                        </section>
                    )}
                    <section className="container flex flex-wrap m-auto justify-center md:my-10" style={{ maxWidth: "1170px" }}>
                        <ServicesList list={data.serviceCategories.edges} currentPage={data.service.uri} helpBanner={data.helpBanner} promoBanner={data.service.promoBanner} contact={data.template.contactInformationTemplate} />
                        <ServiceContent content={data.service.content} featured={data.service.servicesAcf.featuredImage} />
                    </section>
                    <section  style={{position:"relative", zIndex: "9"}}>
                        {(data.service.faqsAcf.faqs && data.service.faqsAcf.faqs.faqs && data.service.faqsAcf.faqs.faqs.length > 0) && (
                            <Faqs
                                data={data.service.faqsAcf.faqs}
                            />
                        )}
                    </section>
                </div>
            </Layout>
        </div>

    )
}

export default ServiceTemplate

export const pageQuery = graphql`query GET_SERVICE($id: ID!, $language: WPGraphQL_LanguageCodeFilterEnum, $themeTemplateUri: ID!, $helpBannerTemplateUri: ID!) {
  wpgraphql {
    service(id: $id) {
      seo {
        canonical
        title
        metaDesc
        opengraphDescription
        opengraphTitle
        opengraphImage {
          sourceUrl
        }
      }
      breadcrumbAcf {
        breadcrumbName
        image {
          sourceUrl
          altText
          imageFile {
            childImageSharp {
              gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH, quality: 100)
            }
          }
        }
      }
      serviceCategories {
        edges {
          node {
            breadcrumbServicesAcf {
              breadcrumbName
              breadcrumbSlug
            }
          }
        }
      }
      title
      content
      uri
      servicesAcf {
        featuredImage {
          sourceUrl
          altText
          imageFile {
            childImageSharp {
              gatsbyImageData(quality: 80, placeholder: NONE, layout: FULL_WIDTH)
            }
          }
        }
      }
      faqsAcf {
        faqs {
          title
          faqs {
            question
            answer
            visibleInSite
          }
        }
      }
      promoBanner {
        image {
            sourceUrl
            altText
            imageFile {
                childImageSharp {
                gatsbyImageData(quality: 80, placeholder: NONE, layout: FULL_WIDTH)
                }
            }
        }
        url
        }
    }
    serviceCategories(where: {language: $language}) {
      edges {
        node {
          name
          services(first: 200, where: {orderby: {field: MENU_ORDER, order: ASC}}) {
            edges {
              node {
                id
                uri
                title
              }
            }
          }
        }
      }
    }
    template(id: $themeTemplateUri, idType: SLUG) {
      contactInformationTemplate {
        telephoneNumber
        supportEmail
        hoursLabel
        hoursTitle
        form {
          title
          subTitle
          fullName
          email {
            label
            errorMessage
          }
          subject
          message {
            label
            errorMessage
          }
          telephone {
            label
            errorMessage
          }
          sendButton
        }
        responseMessages {
          success
          failed
        }
      }
    }
    helpBanner: template(id: $helpBannerTemplateUri, idType: SLUG) {
      serviceHelpBanner {
        title
        content
        image {
          sourceUrl
          altText
          imageFile {
            childImageSharp {
              gatsbyImageData(
                width: 360
                quality: 80
                placeholder: NONE
                layout: CONSTRAINED
              )
            }
          }
        }
        icon {
          altText
          sourceUrl
          imageFile {
            childImageSharp {
              gatsbyImageData(width: 38, quality: 100, placeholder: NONE, layout: FIXED)
            }
          }
        }
      }
    }
    posts(
      first: 2
      where: {language: $language, orderby: {field: DATE, order: ASC}}
    ) {
      ...RecentPostsFragment
    }
  }
}
`